import { call, put } from 'redux-saga/effects';
import * as api from 'reduxStore/apiService';
import apiUrl from 'common/api-url';
import App from 'common/backbone-app';
import Wahanda from 'common/wahanda';
import { mergeQuotesIntoDailyReport, QuoteDailyReport } from 'services/quote-daily-report';
import {
  dailyReportRequest,
  dailyReportSuccess,
  dailyReportFailure,
  quoteDailyReportFailure,
} from './actions';
import { DailyReport } from './types';
import { ENABLE_QUOTES, ENABLE_QUOTES_BY_COUNTRY } from 'common/feature-flags';

const emptyPosDailyReport = (date: string): Record<string, unknown> => ({
  date,
  transactions: [],
});

export function* getDailyReport(action: ReturnType<typeof dailyReportRequest>) {
  const date = action.payload.date;

  const canManageQuotes =
    App.isMasquerading() ||
    (typeof Wahanda.Permissions.manageQuotes === 'function' && Wahanda.Permissions.manageQuotes());
  const isQuotesFlagEnabled =
    Wahanda.Features.isEnabled(ENABLE_QUOTES) ||
    Wahanda.Features.isEnabled(ENABLE_QUOTES_BY_COUNTRY);
  const quotesDailyReportEnabled = isQuotesFlagEnabled && canManageQuotes;

  let posDailyReport: Record<string, unknown> | null = null;
  try {
    posDailyReport = yield call(api.get, apiUrl('POS_DAILY_REPORT', { date }));
  } catch {
    posDailyReport = null;
  }

  let quoteDailyReport: QuoteDailyReport | null = null;
  let quoteDailyReportFailed = false;
  if (quotesDailyReportEnabled) {
    try {
      quoteDailyReport = (yield call(
        api.get,
        apiUrl('QUOTE_DAILY_REPORT', { date }),
      )) as QuoteDailyReport;
    } catch {
      quoteDailyReport = null;
      quoteDailyReportFailed = true;
    }
  }

  if (quoteDailyReportFailed) {
    yield put(quoteDailyReportFailure());
  }

  if (!posDailyReport) {
    if (!quoteDailyReport) {
      yield put(dailyReportFailure());
      return;
    }
    posDailyReport = emptyPosDailyReport(date);
  }

  const merged = mergeQuotesIntoDailyReport(posDailyReport, quoteDailyReport);
  yield put(dailyReportSuccess((merged as unknown) as DailyReport));
}
